export const FIRST_CONFIG_RETURN_URL_KEY = 'firstConfigReturnUrl';

export function isAllowedReturnUrl(url: string, allowedOrigins: string[]): boolean {
  try {
    const parsed = new URL(url);
    if (parsed.pathname !== '/' && parsed.pathname !== '') {
      return false;
    }
    return allowedOrigins.includes(parsed.origin);
  } catch {
    return false;
  }
}

export function storeReturnUrlFromQuery(allowedOrigins: string[]): void {
  const params = new URLSearchParams(window.location.search);
  const returnUrl = params.get('returnUrl');
  if (!returnUrl || !isAllowedReturnUrl(returnUrl, allowedOrigins)) {
    return;
  }

  sessionStorage.setItem(FIRST_CONFIG_RETURN_URL_KEY, returnUrl);

  params.delete('returnUrl');
  const query = params.toString();
  const cleanUrl = `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`;
  window.history.replaceState({}, '', cleanUrl);
}

export function getStoredReturnUrl(): string | null {
  return sessionStorage.getItem(FIRST_CONFIG_RETURN_URL_KEY);
}

export function clearStoredReturnUrl(): void {
  sessionStorage.removeItem(FIRST_CONFIG_RETURN_URL_KEY);
}
